import './App.css';
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './player/Home';
import Work from './player/Work';
import About from './player/About';
import Layout from './player/Layout';
import Moonicon from 'remixicon-react/MoonFillIcon'
import { useState } from 'react';
import { DarkModeProvider } from './DarkModeContext';
import Memory from './player/Memory';
function App() {
  return (
    <DarkModeProvider>
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="work" element={<Work />} />
          <Route path='about' element={<About />} />
          <Route path='memory' element={<Memory />} />
        </Route>
      </Routes>
    </Router>
  </DarkModeProvider>
  );
}
export default App;

